import type { ContactRequest } from '@modules/_shared/utils/contactRequest';

type ContactRequestEnquiry = {
  created_at: string;
  first_name?: string | null;
  last_name?: string | null;
  email_address?: string | null;
  phone_number?: string | null;
  contact_reason?: string | null;
  message?: string | null;
  broker?: {
    full_name?: string | null;
  } | null;
  team?: {
    name: string;
  } | null;
  property_transaction?: ContactRequest['transaction'];
};

export const mapEnquiryToContactRequest = (
  enquiry: ContactRequestEnquiry,
): ContactRequest => ({
  created_at: enquiry.created_at,
  contact: {
    full_name:
      [enquiry.first_name, enquiry.last_name].filter(Boolean).join(' ') || null,
    phone_numbers: enquiry.phone_number
      ? [{ number: enquiry.phone_number }]
      : [],
    emails: enquiry.email_address ? [{ email: enquiry.email_address }] : [],
  },
  agent: { full_name: enquiry.broker?.full_name },
  team: enquiry.team,
  reason: enquiry.contact_reason ?? 'other',
  message: enquiry.message,
  property: enquiry.property_transaction?.property,
  transaction: enquiry.property_transaction,
});
